import { render, staticRenderFns } from "./wildPlants.vue?vue&type=template&id=7ff5572e&scoped=true&"
import script from "./wildPlants.vue?vue&type=script&lang=js&"
export * from "./wildPlants.vue?vue&type=script&lang=js&"
import style0 from "./wildPlants.vue?vue&type=style&index=0&id=7ff5572e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff5572e",
  null
  
)

export default component.exports